<div *ngIf="fileUrl" class="iframe-box">
  <iframe [src]="fileUrl" width="100%" height="100%" frameborder="0"></iframe>
</div>
